import React from "react";
import { useDispatch } from "react-redux";
import { selectedAuthor, selectedCategory } from "../redux/filters/actions";

const Blog = ({ blog }) => {
    const { category, title, authorName, authorImg, minRead, createdAt, img } =
        blog;
    const dispatch = useDispatch();

    const handleCategoryFilter = (e) => {
        dispatch(selectedCategory(e.target.innerText));
    };

    const handleAuthorFilter = (e, clicked) => {
        if (clicked === "img") {
            dispatch(selectedAuthor(e.target.alt));
        } else {
            dispatch(selectedAuthor(e.target.innerText));
        }
    };

    return (
        <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
            <div className="flex-shrink-0">
                <img className="h-48 w-full object-cover" src={img} alt="" />
            </div>

            <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                <div className="flex-1">
                    <p
                        onClick={handleCategoryFilter}
                        className="text-sm font-medium text-indigo-600 cursor-pointer"
                    >
                        <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800">
                            {category}
                        </span>
                    </p>
                    <a href="#" className="block mt-1">
                        <p className="text-xl font-semibold text-gray-900">
                            {title}
                        </p>
                    </a>
                </div>
                <div className="mt-6 flex items-center">
                    <div className="flex-shrink-0">
                        <img
                            onClick={(e) => handleAuthorFilter(e, "img")}
                            className="h-10 w-10 rounded-full cursor-pointer"
                            src={authorImg}
                            alt={authorName}
                        />
                    </div>
                    <div className="ml-3">
                        <p
                            onClick={(e) => handleAuthorFilter(e, "name")}
                            className="text-sm font-medium text-gray-900 hover:underline cursor-pointer"
                        >
                            {authorName}
                        </p>
                        <div className="flex space-x-1 text-sm text-gray-500">
                            <time dateTime="2020-03-16">{createdAt}</time>
                            <span aria-hidden="true">&middot;</span>
                            <span> {minRead} min read </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog;
